const link_list = {
    routePath: 'applicationbudgets',
    actionName: 'count',
    iconClass: 'fa-solid fa-file',
    title: 'My Active Application Budgets',
    search: '',
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: '',
}
export default {link_list }